import axios from 'axios';
import { apiRoutes } from '../../apiRoutes';
import { authHeader } from '../../global';
import moment from 'moment'


import Vue from 'vue'


const getDefaultStateForRevision = () => {
  return {
    revisions: [],
    data:{},
    revision_created:null,
    is_retrieved:null
  }
}

// state
const state = getDefaultStateForRevision()

// getters
const getters = {

}

// mutations
const mutations = {
    RESET_STATE_FOR_REVISION (state) {
      Object.assign(state, getDefaultStateForRevision())
    },
    SET_IS_CREATED (state, data) {
        state.revision_created = data
    },
    SET_IS_RETRIEVE (state, data) {
      state.is_retrieved = data
    },
    FETCH_ALL(state, data){
        data.forEach(function (element) {
          element.time_created = (element.time_created != null && element.time_created != '') ? (moment(element.time_created).format('DD/MM/YYYY, h:mm a')) : '-'
        });
        state.revisions = data
    },
    FETCH (state, data) {
      state.data = data
  },
}

// actions
const actions = {
    resetState({ commit }, payload) {
      commit("RESET_STATE_FOR_REVISION")
    },
    fetchAll({ commit }, data) {
        return axios.post(apiRoutes['LIST_DOCUMENT_REVISIONS'], data, authHeader())
            .then(response => {
              if(response.data.code == 1){
                commit('FETCH_ALL', response.data.data)
              } else {
                commit('FETCH_ALL', [])
              }
            })
            .catch(error => {
              if (error.response) {
                console.log(error.response)
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.msg,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              } else {
                  console.log("Problem Querying Data!", error);
              }
          });
    },
    fetch({ commit }, data) {
      return axios.post(apiRoutes['RETRIEVE_DOCUMENT_REVISION'], data, authHeader())
          .then(response => {
            if(response.data.code == 1)
            {
              commit('FETCH', response.data.data)
              commit('SET_IS_RETRIEVE', 1)

            } 
            else 
            {
              commit('FETCH', {})
              commit('SET_IS_RETRIEVE', 0)
            }
          })
          .catch(error => {
            if (error.response) {
              console.log(error.response)
                Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: error.response.data.msg,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
            } else {
                console.log("Problem Querying Data!", error);
            }
        });
  },
    async create({ commit, dispatch }, data) {
        let apiCreateRevision  = apiRoutes['CREATE_DOCUMENT_REVISIONS'];
    
        await axios.post(apiCreateRevision, data, authHeader())
            .then(function (response) {
              if(response.data.code == 1)
              {
                let doc_number  = response.data.data.code
                Vue.notify({
                    group: 'notify',
                    type: 'success',
                    text: 'Sales (' + doc_number + ')' + " has been updated!",
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
    
                commit('SET_IS_CREATED', 1);
              }
              else
              {
                  let errors = response.data.data.errors

                  //alert("ERRORS")
                      
                  if(Array.isArray(errors))
                  {
                    let msg = errors.join("\n")
                    Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: msg,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
                  }
                  commit('SET_IS_CREATED', 0);
              }
    
            })
            .catch((error) => {
                // alert(error)
                // console.log(error.response)
    
                if (error.response) {
                    //alert(error.response.data.message)
                    Vue.notify({
                        group: 'notify',
                        type: 'error',
                        text: error.response.data.message,
                        max: 5,
                        duration: 5000,
                        speed: 300
                    })
                }
                else
                {
                    //console.log("Problem submitting New Post", error);
                    alert("Application Error")
                }
            });
      },

}

export {
    state,
    getters,
    actions,
    mutations
}
